
import AppBillboard from "@/components/login/Billboard.vue";
import AppHeadingInput from "@/components/init-modal/HeadingInput.vue";
import AppLogoUpload from "@/components/init-modal/LogoUpload.vue";
import AppPeppolSetup from "@/components/init-modal/PeppolSetup.vue";
import { ReminderLayoutConf } from "@/models/reminder-layout";
import { DossierConfigService } from "@/services/dossier-config-service";
import { MailSettingsService } from "@/services/mail-settings-service";
import { ReminderService } from "@/services/reminder-service";
import { SaleService } from "@/services/sale-service";
import { DocumentLayoutLogo } from "@/utils/documents/layout-logo";
import { InitInfo } from "@/utils/init-info";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
import Vue from "vue";
import { PriceFrequencyType, Pricing } from "../models/payment/pricing";
import { Plan } from "../utils/payments/plan";
import { AuthService } from "../services/auth-service";
import { PaymentService } from "../services/payment-service";
import { Tier } from "../utils/payments/tiers";
import { DocumentLayoutHeading } from "@/utils/documents/layout-heading";
import { SaleLayoutLogo } from "@/utils/sale-layouts/logo";

let defaultReminderLayout = require("../assets/json/default-reminder-layout.json");

export default Vue.extend({
	data() {
		return {
			currentPage: "loading",
			content: new InitInfo(),
			fadeClass: "fadeInRight",
			pricing: new Pricing() as Pricing,
			step: 1,
			controlsDisabled: false
		};
	},
	computed: {
		currentPlan(): Plan {
			return new Plan({tier: -1});
		},
		paymentFrequencyType(): PriceFrequencyType {
			return PriceFrequencyType.DEMO;
		},
	},
	methods: {
		logout() {
			this.$emit("logout");
		},
		switchFade() {
			this.fadeClass = "fadeInLeft";
			setTimeout(() => {
				this.fadeClass = "fadeInRight";
			}, 2000);
		},
		async order() {
			let p = new Plan();
			p.tier = Tier.PROFESSIONAL;
			//await CompanyService.updateDemoTier(p.tier, p.modules);
			//this.currentPage = "loading";
		},
		async finish() {
			this.controlsDisabled = true;
			try{
				this.order();
				let layouts = await SaleService.getSaleLayouts();
				if (layouts.length == 0){
					await SaleService.initSaleLayouts(this.content);
					await this.createReminderLayout(defaultReminderLayout,this.$ct("default-layout").toString());
				}
				this.controlsDisabled = false;
				await this.setMailSettings();
				await this.createReportConfig();

				let config = DossierConfigService.getGeneralConfig();
				config.HideInitModal = true;
				config.ShowQuickStart = true;
				await DossierConfigService.saveGeneralConfig(config);
				this.$emit("close");
			}catch(err){

			}
			this.controlsDisabled = false;
		},

		async createReminderLayout(layout:ReminderLayout,name:string) {
			try{
				let reminderLayout = new ReminderLayoutConf();
				reminderLayout.Data = new ReminderLayout(JSON.parse(JSON.stringify(layout)));
				reminderLayout.Name = name;
				this.setDocumentHeadingValues(reminderLayout.Data.Heading);
				await ReminderService.postReminderLayout([reminderLayout]);
			}catch(err){

			}
			this.controlsDisabled = false;
		},
		async setMailSettings() {
			let mailSettings = await MailSettingsService.getDefaultSettings();
			mailSettings.EmailName = this.content.companyName;
			mailSettings.EmailFrom = this.content.email;
			mailSettings = await MailSettingsService.updateSettings(mailSettings, false);
		},
		setDocumentHeadingValues(heading: DocumentLayoutHeading) {
			heading.Heading1.setText(this.content.companyName);
			heading.Heading2.setText(this.content.addressLine1);
			heading.Heading3.setText(this.content.postalAndPlace);
			heading.Heading4.setText(this.content.tel);
			heading.Heading6.setText(this.content.vatNo);
			heading.Heading7.setText(this.content.bank);
			heading.Heading8.setText(this.content.email);
		},
		createDocumentLogos(token: string, logo:DocumentLayoutLogo | SaleLayoutLogo) {
			logo.ImageToken = token;
			logo.Placement = "Heading";
			logo.X = 0;
			logo.Y = 9;
			logo.Width = 77;
			logo.Height = 22;
			return logo;
		},

		async createReportConfig() {
			let config = DossierConfigService.getDefaultReportConfig();
			config.Heading.Heading1.Value = this.content.companyName;
			config.Heading.Heading2.Value = this.content.addressLine1;
			config.Heading.Heading3.Value = this.content.postalAndPlace;
			await DossierConfigService.saveDefaultReportConfig(config);
		}
	},
	async created() {
		if (AuthService.wfCompany.IsDemo) {
			this.pricing = await PaymentService.getPricing();
			setTimeout(() => this.currentPage = "heading", 4000);
			this.step = 2;
		} else if (!AuthService.wfCompany.isExpired()) {
			setTimeout(() => this.currentPage = "heading", 4000);
		} else {
			this.pricing = await PaymentService.getPricing();
			setTimeout(() => this.currentPage = "plan", 4000);
		}
	},
	components: {
		AppHeadingInput,
		AppLogoUpload,
		AppPeppolSetup,
		AppBillboard
	},
	i18nEx: {
		componentPrefix: "components.init-modal"
	}
});
